'use client';

import { FC } from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import { BlogSectionType } from '../../models/Content';
import { SectionImage } from './SectionImage/SectionImage';
import { SectionNote } from './SectionNote/SectionNote';
import { SectionQuote } from './SectionQuote/SectionQuote';
import { SectionText } from './SectionText/SectionText';
import { SectionVideo } from './SectionVideo/SectionVideo';
import { SectionYoutubeEmbed } from './SectionYoutubeEmbed/SectionYoutubeEmbed';
import { transformBlogSection } from './transformers';

type Props = {
    contentItem: BlogSectionType;
};

export const BlogSection: FC<Props> = ({ contentItem: initialContentItem }) => {
    const contentItem = useContentfulLiveUpdates(initialContentItem);
    const { type } = transformBlogSection(contentItem);

    if (type === 'text') {
        return <SectionText contentItem={contentItem} />;
    }

    if (type === 'note') {
        return <SectionNote contentItem={contentItem} />;
    }

    if (type === 'quote') {
        return <SectionQuote contentItem={contentItem} />;
    }

    if (type === 'highlight') {
        return <SectionNote contentItem={contentItem} $highlight={true} />;
    }

    if (type === 'image') {
        return <SectionImage contentItem={contentItem} />;
    }

    if (type === 'video') {
        return <SectionVideo contentItem={contentItem} />;
    }

    if (type === 'youtube-embed') {
        return <SectionYoutubeEmbed contentItem={contentItem} />;
    }

    return null;
};
